import { ChevronRightIcon } from '@chakra-ui/icons';
import { Breadcrumb as ChakraBreadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';

type link = {
  link: string;
  title: string;
};

type BreadcrumbProps = {
  linkList: link[];
  color?: string;
};

const Breadcrumb = ({ linkList, color }: BreadcrumbProps) => {
  return (
    <>
      <ChakraBreadcrumb spacing='8px' separator={<ChevronRightIcon color='gray.500' />}>
        {linkList.map((item, index, arr) => {
          let isCurrentPage = index === arr.length - 1 ? true : false;
          return (
            <BreadcrumbItem key={item.title} isCurrentPage={isCurrentPage}>
              <BreadcrumbLink
                href={item.link}
                color={isCurrentPage ? color || 'blue.5' : 'primary.grey'}
                fontSize='20px'
                fontWeight={isCurrentPage ? 700 : 300}
              >
                {item.title}
              </BreadcrumbLink>
            </BreadcrumbItem>
          );
        })}
      </ChakraBreadcrumb>
    </>
  );
};

export { Breadcrumb };
